import OpenAPIClientAxios from 'openapi-client-axios';
import AJV from 'ajv';


const QUEUE = [];

export let API = null;

export let API_OPTIONS = null;


/**
 * @param {Object} Vue
 * @param {Object} options {apiClient: {ajvOptions, ajvHook}}
 */
export default (Vue, {apiClient: options}) => {

  // Queue functions until session is loaded.
  Vue.prototype.$apiClient = (...args) => {
    return new Promise((resolve, reject) => {
      QUEUE.push({args, promise: {resolve, reject}});
    });
  };


  // Watch for session changes.
  Vue.store.watch(() => Vue.store.getters['session/getUser'], async (session) => {
    let client_error = null;
    if (!session.loggedIn) {
      client_error = new Error('Not authorized.');

    } else if (!session.client) {
      client_error = new Error('Not configured. \`session.client\` missing.');
    }

    let client = null;
    if (client_error) {
      API = null;

    } else {
      try {
        const optionsChanged = !!API && JSON.stringify(API_OPTIONS) !==
          JSON.stringify(session.client.options);

        if (!API || optionsChanged) {
          API_OPTIONS = session.client.options; // Store current api options.
          API = new OpenAPIClientAxios(API_OPTIONS);
          client = await API.init();

        } else {
          client = await API.getClient();
        }

        // Set Authorization Header.
        client.defaults.headers.Authorization = `Bearer ${session.client.token}`;

      } catch (error) {
        API = null;
        API_OPTIONS = null;
        client_error = error;
      }
    }

    const exec = async (operationId, parameters = {}, data, config) => {
      if (client_error) {
        throw client_error;
      }
      try {
        const operation = API.getOperation(operationId);
        if (!operation) {
          throw new Error(`Unknown OperationId "${operationId}".`);
        }

        const schema = operation.requestBody && operation.requestBody.content &&
          operation.requestBody.content['application/json'] && operation.requestBody.content['application/json'].schema;

        if (schema) {
          const ajv = new AJV({
            removeAdditional: 'failing',
            coerceTypes: false,
            ...options.ajvOptions || {}
          });
          if (typeof options.ajvHook === 'function') {
            await options.ajvHook(ajv);
          }
          const validate = ajv.compile(schema);
          const d = JSON.parse(JSON.stringify(data)); // decouple data, since we do not want to modify the references here
          validate(d);
          data = d;
        }

        // Add add global parameters to each request (e.g. account/namespace).
        parameters = {
          ...parameters,
          ...session.client.parameters
        };
        return await client[operationId](parameters, data, config);

      } catch (error) {
        if (error.response && error.response.status === 401) {
          await Vue.auth.verifyUser(); // Check if user is loggedIn
        }
        throw error;
      }
    };

    // Work off queue.
    while (QUEUE.length) {
      const item = QUEUE.shift();

      exec.apply(null, item.args)
          .then(item.promise.resolve)
          .catch(item.promise.reject);
    }

    // Replace queue with api client.
    Vue.prototype.$apiClient = exec;
  });
};
